/* tslint:disable */
/* eslint-disable */
/**
 * Calvin Risk API
 * TBD
 *
 * The version of the OpenAPI document: 6.0.0
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { RiskDimension } from './RiskDimension';
import { RiskDimensionFromJSON, RiskDimensionFromJSONTyped, RiskDimensionToJSON } from './RiskDimension';
import type { RiskDimensionLabel } from './RiskDimensionLabel';
import {
  RiskDimensionLabelFromJSON,
  RiskDimensionLabelFromJSONTyped,
  RiskDimensionLabelToJSON,
} from './RiskDimensionLabel';

/**
 *
 * @export
 * @interface CustomQuestionnaireResultDimensionRisk
 */
export interface CustomQuestionnaireResultDimensionRisk {
  /**
   *
   * @type {RiskDimension}
   * @memberof CustomQuestionnaireResultDimensionRisk
   */
  readonly dimension: RiskDimension;
  /**
   *
   * @type {RiskDimensionLabel}
   * @memberof CustomQuestionnaireResultDimensionRisk
   */
  readonly label: RiskDimensionLabel;
}

/**
 * Check if a given object implements the CustomQuestionnaireResultDimensionRisk interface.
 */
export function instanceOfCustomQuestionnaireResultDimensionRisk(
  value: object,
): value is CustomQuestionnaireResultDimensionRisk {
  if (!('dimension' in value) || value['dimension'] === undefined) return false;
  if (!('label' in value) || value['label'] === undefined) return false;
  return true;
}

export function CustomQuestionnaireResultDimensionRiskFromJSON(json: any): CustomQuestionnaireResultDimensionRisk {
  return CustomQuestionnaireResultDimensionRiskFromJSONTyped(json, false);
}

export function CustomQuestionnaireResultDimensionRiskFromJSONTyped(
  json: any,
  ignoreDiscriminator: boolean,
): CustomQuestionnaireResultDimensionRisk {
  if (json == null) {
    return json;
  }
  return {
    dimension: RiskDimensionFromJSON(json['dimension']),
    label: RiskDimensionLabelFromJSON(json['label']),
  };
}

export function CustomQuestionnaireResultDimensionRiskToJSON(
  value?: Omit<CustomQuestionnaireResultDimensionRisk, 'dimension' | 'label'> | null,
): any {
  if (value == null) {
    return value;
  }
  return {};
}
